<app-modal-refactor
  [size]="sizeModal || 'lg'"
  [showImage]="!!image"
  [image]="image"
  [isVerPass]=true
  [imageClose]="'../../../assets/images/Close_modal.svg'"
  [showImageClose]=true
>
  <div body class="containerError">
    <span class="tittleError gapline">{{ titleError | translate }}</span>
    <span class="gapline text-white descError" style="margin-bottom: 0;" [innerText]="msgError | translate"> </span>
    <span *ngIf="!isAllPass" class="textpasseger gapline text-white" >{{ 'modalVenezuela.passtitle' | translate}}</span>
    <div *ngIf="!isAllPass"><span *ngFor="let p of passengerSelected" class="textpss-labels">{{ p.displayName | titlecase }}<br></span></div>

    <div class="errorsBtnsPnr gapline">
      <button *ngIf="showCancelButton" type="button" class="error-btn {{backGroundButton}} {{colorFontButton}}" (click)="actionBtnCancel()">
        <div class="error-btn-container">
          <span>{{ cancelButtonText | translate }}</span>
        </div>
      </button>
    </div>
    <div>
      <span class="errorNumberDescrip">{{codeError}} </span>
    </div>
  </div>
</app-modal-refactor>
